import { z } from "zod";
import { ENDING_RARITY_VALUES } from "../../constants/ending-rarity.js";
import { STORY_STATUS_VALUES } from "../../constants/story-status.js";
export const AdminStatsEndingSchema = z.object({
    endingId: z.uuid(),
    name: z.string(),
    rarity: z.enum(ENDING_RARITY_VALUES),
    unlockedCount: z.number().int().nonnegative(),
});
export const AdminStatsStorySchema = z.object({
    storyId: z.uuid(),
    title: z.string(),
    status: z.enum(STORY_STATUS_VALUES),
    likesCount: z.number().int().nonnegative(),
    commentsCount: z.number().int().nonnegative(),
    bookmarksCount: z.number().int().nonnegative(),
    playthroughsCount: z.number().int().nonnegative(),
    completedCount: z.number().int().nonnegative(),
    endings: z.array(AdminStatsEndingSchema),
});
export const AdminStatsSchema = z.object({
    usersCount: z.number().int().nonnegative(),
    seriesCount: z.number().int().nonnegative(),
    storiesCount: z.number().int().nonnegative(),
    publishedStoriesCount: z.number().int().nonnegative(),
    playthroughsCount: z.number().int().nonnegative(),
    completedPlaythroughsCount: z.number().int().nonnegative(),
    stories: z.array(AdminStatsStorySchema),
});
